// Material Dashboard 2 PRO React base styles
import boxShadows from "assets/theme/base/boxShadows";
import typography from "assets/theme/base/typography";
import colors from "assets/theme/base/colors";
import borders from "assets/theme/base/borders";

// Material Dashboard 2 PRO React helper functions
import pxToRem from "assets/theme/functions/pxToRem";
import renderTags, { renderOption } from "assets/theme/components/form/autocompleteRenderTags";

const { lg } = boxShadows;
const { size } = typography;
const { text, white, transparent, light, dark, gradients } = colors;
const { borderRadius } = borders;

const autocomplete = {
  // Çoklu seçim etiketleri ve seçenek listesi: key yayılmadan çizilir (React 18.3 konsol uyarısı)
  defaultProps: { renderTags, renderOption },

  styleOverrides: {
    popper: {
      boxShadow: lg,
      padding: pxToRem(8),
      fontSize: size.sm,
      color: text.main,
      textAlign: "left",
      backgroundColor: `${white.main} !important`,
      borderRadius: borderRadius.md,
    },

    paper: {
      boxShadow: "none",
      backgroundColor: transparent.main,
    },

    option: {
      padding: `${pxToRem(4.8)} ${pxToRem(16)}`,
      borderRadius: borderRadius.md,
      fontSize: size.sm,
      color: text.main,
      transition: "background-color 300ms ease, color 300ms ease",

      "&:hover, &:focus, &.Mui-selected, &.Mui-selected:hover, &.Mui-selected:focus":
        {
          backgroundColor: light.main,
          color: dark.main,
        },

      '&[aria-selected="true"]': {
        backgroundColor: `${light.main} !important`,
        color: `${dark.main} !important`,
      },
    },

    noOptions: {
      fontSize: size.sm,
      color: text.main,
    },

    groupLabel: {
      color: dark.main,
    },

    loading: {
      fontSize: size.sm,
      color: text.main,
    },

    inputRoot: {
      display: "flex",
      alignItems: "center",
      flexWrap: "wrap",          // 🔑 chip’lerin satıra sığmasını sağlar
      padding: "8px !important",
      minHeight: "48px",         // 🔑 input yüksekliği sabitlenir
    },

    tag: {
      display: "flex",
      alignItems: "center",
      minHeight: 32,              // ✅ chip boyutu
      padding: "6px 6px",
      margin: "4px",
      borderRadius: "16px",
      backgroundColor: gradients.dark.state,
      color: white.main,

      "& .MuiChip-label": {
        padding: "0 8px",
        fontSize: "0.75rem",      // ✅ okunur
        lineHeight: 1.4,
      },

      "& .MuiChip-deleteIcon": {
        color: white.main,        // ✅ X görünür
        opacity: 0.8,
        fontSize: "18px",

        "&:hover": {
          opacity: 1,
        },
      },
    },

    endAdornment: {
      top: "50%",
      transform: "translateY(-50%)",
    },


  },
};

export default autocomplete;
